export default __webpack_public_path__ + "static/media/ig.f7b3dff3.png";